import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/ui-kit";

// Consistent premium page header used across interior pages.
export function PageHero({ eyebrow, title, subtitle, testId }) {
  return (
    <section data-testid={testId} className="relative bg-black noise pt-40 pb-20 lg:pt-48 lg:pb-28">
      <div className="relative z-10 max-w-[1000px] mx-auto px-6 lg:px-10">
        {eyebrow && (
          <Reveal>
            <Eyebrow>{eyebrow}</Eyebrow>
          </Reveal>
        )}
        <Reveal delay={90}>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white mt-7 tracking-tight leading-[1.02]">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={170}>
            <p className="font-body text-lg lg:text-xl text-white/55 font-light mt-8 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export default PageHero;
